import router from '@/router/index';

import { getRouterByUser } from '@/router/index';
// import { initRouter } from '@/utils/routerUtil';
// import { useRouterStore } from '@/store/routerStore';
// const useRouterEvent = useRouterStore();

// 白名单，不需要进行权限验证的路由名称
const whiteList = ['Login'];

let routeList = [];

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  // 获取 token
  const hasToken = localStorage.getItem('ssptoken');

  if (hasToken) {
    routeList = router.getRoutes();
    if (to.name === 'Login') {
      // 重新拿路径
      routeList = router.getRoutes();

      // 如果已经登录，访问登录页，重定向到主页
      next({ path: '/home' });
    } else {
      const redirect = decodeURIComponent(from.query.redirect || to.path);
      // 桌面特殊处理
      if (to.path === '/home' || to.path === '/404') {
        next();
      } else {
        // await getRouterByUser(); // 可以成功跳转，但页面刷新显示空白

        if (to.path === redirect) {
          getRouterByUser(); // 原
          routeList = router.getRoutes();

          let foundRoute = {};
          foundRoute = routeList.find((route) => route.path === to.path);

          if (foundRoute) {
            next();
          } else {
            // 路径不在权限内，跳转404
            next({ path: '/404' });
          }
        } else {
          // 跳转到目的路由
          next({ path: redirect });
        }
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在白名单中，直接放行
      next();
    } else {
      // 没有 token 且不在白名单中，重定向到登录页
      next({ name: 'Login', query: { redirect: to.fullPath } });
    }
  }
});

// 全局后置钩子
router.afterEach(() => {});

export default router;
